import { readonly, ref } from "vue";
import { PublicPaymentUseCases } from "@/application/use-cases/PublicPaymentUseCases";
import { useLogger } from "./useLogger";
export function useCancelPaymentAndReturn() {
    const logger = useLogger();
    const publicPaymentUseCases = new PublicPaymentUseCases();
    const isCancelling = ref(false);
    const cancelAndReturn = async (paymentId, returnUrl) => {
        if (isCancelling.value) {
            return;
        }
        isCancelling.value = true;
        logger.debug("Cancelling payment...");
        try {
            await publicPaymentUseCases.cancelPayment(paymentId);
        }
        catch (error) {
            isCancelling.value = false;
            throw error;
        }
        logger.debug("Payment cancelled successfully, redirecting...");
        if (returnUrl) {
            // CONSTRAINT: isCancelling stays true until the page unloads. Callers lock their other actions on it,
            // and the payment is already cancelled: unlocking here would let the payer retry it.
            window.location.href = returnUrl;
        }
        else {
            isCancelling.value = false;
        }
    };
    return {
        isCancelling: readonly(isCancelling),
        cancelAndReturn,
    };
}
